export const VIEWER_MODE_BANNER = "activation.settings.viewer.mode.banner";
